import { routes } from '../RouterPath';
import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const menuEditBreadcrumbs = (filterName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Меню',
        url: routes.menu,
    },
    {
        key: '3',
        value: filterName,
        url: '',
    },
]);
